export default {
  SET_BUTTONTYPE(state, payload) {
    state.buttonType = payload;
  },
};
